import getStore from 'services/getStore';

let moduleImages = [];

const getModuleImages = (blocks = null) => {
  if (moduleImages.length) {
    return moduleImages;
  }

  const interactionBackgrounds = [];
  const images = [];

  // will fix this up later
  let blocks_ = getStore().getState().blocks as any; // blocks;

  Object.values(blocks_).forEach((b: any) => {
    switch (b.type) {
      case 'Interaction': {
        b.type === 'Interaction' &&
          b.props.background &&
          b.props.background.includes('url') &&
          interactionBackgrounds.push(b.props.background.split(/url\(|\)/g)[1]);
      }
      case 'Image': {
        b.props.src && images.push(b.props.src);
      }
    }
  });

  return (moduleImages = [...interactionBackgrounds, ...images]);
};

export default getModuleImages;
